module.exports = __webpack_public_path__ + "img/zuhao.6c49c8c2.jpg";